import styled from 'styled-components';

export const StyledOfficer = styled.div`
    p {
        text-align: left;
    }
`